import { HelpTip } from './types';

export const COSTINGS_TIPS = {
  repairServicesTable: {
    title: { fr: 'Prestations de réparation', en: 'Repair services' },
    text: {
      fr: "Catalogue des types d'intervention (débosselage, peinture, remplacement…) proposés pour réparer un dommage. Une prestation n'a pas de prix en elle-même : son coût est défini dans les grilles de chiffrage, pour chaque couple équipement / dommage.",
      en: 'Catalogue of the types of work (dent removal, painting, replacement…) offered to repair a damage. A service has no price by itself: its cost is defined in the costing grids, for each equipment / damage pair.',
    },
    docSlug: 'prestations-de-reparation',
  },
  repairServiceStatusColumn: {
    title: { fr: 'État de la prestation', en: 'Service status' },
    text: {
      fr: "Indique si la prestation est active ou inactive. Désactiver une prestation ne supprime ni ne modifie les lignes de chiffrage qui l'utilisent : pour ne plus proposer un coût, désactivez la ligne de chiffrage correspondante.",
      en: 'Shows whether the service is active or inactive. Deactivating a service neither deletes nor changes the costing lines using it: to stop offering a cost, deactivate the matching costing line.',
    },
    docSlug: 'prestations-de-reparation',
  },
  repairCostingsTable: {
    title: { fr: 'Grilles de chiffrage', en: 'Costing grids' },
    text: {
      fr: "Chaque ligne associe un équipement, un dommage d'un niveau de sévérité donné et une prestation de réparation à un coût en euros. Lorsqu'une inspection détecte ce dommage sur cet équipement, les prestations correspondantes et leur coût sont proposés dans le détail des résultats.",
      en: 'Each line links an equipment, a damage of a given severity level and a repair service to a cost in euros. When an inspection detects this damage on this equipment, the matching services and their cost are shown in the detailed results.',
    },
    docSlug: 'grilles-de-chiffrage',
  },
  costingDamageColumn: {
    title: { fr: 'Dommage et niveau', en: 'Damage and level' },
    text: {
      fr: 'Type de dommage suivi de son niveau de sévérité (1 à 3). Un même type de dommage peut avoir un coût différent selon son niveau : il faut donc une ligne par niveau à chiffrer.',
      en: 'Type of damage followed by its severity level (1 to 3). The same type of damage may have a different cost depending on its level: one line is needed per level to price.',
    },
    docSlug: 'grilles-de-chiffrage',
  },
  costingCostColumn: {
    title: { fr: 'Coût', en: 'Cost' },
    text: {
      fr: "Montant en euros de la prestation pour ce couple équipement / dommage. Une même combinaison équipement + dommage + prestation ne peut exister qu'une seule fois.",
      en: 'Amount in euros of the service for this equipment / damage pair. A given equipment + damage + service combination can only exist once.',
    },
    docSlug: 'grilles-de-chiffrage',
  },
  costingStatusColumn: {
    title: { fr: 'État du chiffrage', en: 'Costing status' },
    text: {
      fr: "Seuls les chiffrages actifs sont proposés dans les résultats d'inspection. Un chiffrage inactif reste visible ici et peut être réactivé depuis sa fiche.",
      en: 'Only active costings are offered in inspection results. An inactive costing stays visible here and can be reactivated from its edit page.',
    },
    docSlug: 'grilles-de-chiffrage',
  },
} satisfies Record<string, HelpTip>;
